import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';


import { API } from '../.././core/app-config';
import { FPResponse } from '../../shared/shared.model';
import { Smslog, technician, frmtechnician, techaddress, techaddressparam, SpErrors, JobDetailpopups, Direction, NearTechparam, nearTechnician, scheduleNeartech, ScheduleNeartechDetail, ColorCode, Region, unassignpanelparam, dropdownlist, GetObjParam, UnAssignJobsdata, SmsLog, weekview, MonthView, MonthViewDays, CompanyWeekends, VendorList, Config, SystemSetting, JobSlaDetails, RequestMonthDayViewData, TechnicianPopupDetails } from './dispatch-board.model';

@Injectable()
export class DispatchBoardService {

    // private states: Observable<State[]>;

    constructor(private http: Http) { }

    //Dropdownlist initial load
    getDropdownlist(companyid: number, loginid: number, maxRoleGroup: number, projectId: number, VendorId: number): Observable<dropdownlist> {
        return this.http.get(API.DISPATCHBOARD + "/GetDropdownlist/" + companyid + "/" + loginid + "/" + maxRoleGroup + '/' + projectId + '/' + VendorId).pipe(map(res => res.json()));
    }
    // Get Region
    getZoneRegionAllotted(GetObjParam: GetObjParam): Observable<Region[]> {debugger;
        return this.http.post(API.DISPATCHBOARD + "/GetRegion", GetObjParam).pipe(map(res => res.json()));
    }
    // Get Technician 
    getTechnician(GetObjParam: GetObjParam): Observable<technician[]> {debugger;
        return this.http.post(API.DISPATCHBOARD + "/GetTechnician", GetObjParam).pipe(map(res => res.json()));
    }
    // Get week view Boarddata
    weekviewBoarddata(param: frmtechnician): Observable<weekview> {debugger;
        return this.http.post(API.DISPATCHBOARD + "/GetWeekViewBoardData", param).pipe(map(res => res.json()));
    }
    // Get technician details
    TechAddress(param: techaddressparam): Observable<techaddress> {
        return this.http.post(API.DISPATCHBOARD + "/GetTechnicianaddress", param).pipe(map(res => res.json()));
    }

    DeAllocatejobs(jobid: number, loginid: number, companyid: number, unassignReason: string, PiSourceId?: number): Observable<SpErrors> {
        return this.http.get(API.DISPATCHBOARD + "/DeAllocationJob/" + jobid + "/" + loginid + "/" + companyid + "/" + unassignReason + "/" + PiSourceId).pipe(map(res => res.json()));
    }

    JobDetails(jobid: number, companyid: number, scheduledate: string, timezoneid: number, jobstatusid: number): Observable<JobDetailpopups> {
        return this.http.get(API.DISPATCHBOARD + "/GetJobDetails/" + jobid + "/" + companyid + "/" + scheduledate + "/" + timezoneid + "/" + jobstatusid).pipe(map(res => res.json()));
    }

    GetDirection(companyid: number, techid: number, jobid: number, scheduledate: string, jobstatusid: number): Observable<Direction> {
        return this.http.get(API.DISPATCHBOARD + "/GetDirectionAddress/" + companyid + "/" + techid + "/" + jobid + "/" + scheduledate + "/" + jobstatusid).pipe(map(res => res.json()));
    }
    GetNearTechnician(param: NearTechparam): Observable<nearTechnician> {
        return this.http.post(API.DISPATCHBOARD + "/GetNearbyTechnician/", param).pipe(map(res => res.json()));
    }
    RescheduleTechnician(param: scheduleNeartech): Observable<SpErrors> {
        return this.http.post(API.DISPATCHBOARD + "/RescheduleTechnician/", param).pipe(map(res => res.json()));
    }
    GetNearTechnicianDetails(param: scheduleNeartech): Observable<ScheduleNeartechDetail> {
        return this.http.post(API.DISPATCHBOARD + "/RescheduleTechnicianDetails/", param).pipe(map(res => res.json()));
    }
    //GetColorCode
    GetColorCode(companyid: number): Observable<ColorCode> {
        return this.http.get(API.DISPATCHBOARD + "/GetColorCode/" + companyid).pipe(map(res => res.json()));
    }
    //GetUnAssignjob
    GetUnAssignJobs(param: unassignpanelparam): Observable<UnAssignJobsdata> {debugger;
        return this.http.post(API.DISPATCHBOARD + "/GetUnAssignJobs/", param).pipe(map(res => res.json()));
    }
    //GetJeoPardyJobs
    GetJeoPardyJobs(param: unassignpanelparam): Observable<UnAssignJobsdata> {
        return this.http.post(API.DISPATCHBOARD + "/GetJeoPardyJobs/", param).pipe(map(res => res.json()));
    }
    ResizeJob(param: scheduleNeartech): Observable<SpErrors> {
        return this.http.post(API.DISPATCHBOARD + "/ResizeJob/", param).pipe(map(res => res.json()));
    }
    SaveSmsLog(param: SmsLog): Observable<FPResponse> {
        return this.http.post(API.DISPATCHBOARD + "/SaveSmslog/", param).pipe(map(res => res.json()));
    }
    // Get Month view Boarddata
    GetMonthViewData(param: frmtechnician): Observable<MonthView> {debugger;
        return this.http.post(API.DISPATCHBOARD + "/GetMonthViewData", param).pipe(map(res => res.json()));
    }

    // region PT-1641  Dispatcher Board- Month View: System fails to hide the jobs based on Customer type in month view. Only empty block should be displayed as in Day/week view.
    // Added/ Modified by Anvardeen Batcha B

    GetMonthDayViewData(request: RequestMonthDayViewData): Observable<MonthViewDays[]> {debugger;
        return this.http.post(API.DISPATCHBOARD + "/GetMonthDayViewData", request).pipe(map(res => res.json()));
    }

    // endregion PT-1641  Dispatcher Board- Month View: System fails to hide the jobs based on Customer type in month view. Only empty block should be displayed as in Day/week view.

    LockSchedule(companyid: number, loginid: number, jobid: number, PiSourceId?: number): Observable<SpErrors> {
        return this.http.get(API.DISPATCHBOARD + "/LockSchedule/" + companyid + "/" + loginid + "/" + jobid + "/" + PiSourceId).pipe(map(res => res.json()));
    }

    CompanyWeekEnds(companyid: number): Observable<CompanyWeekends> {
        return this.http.get(API.DISPATCHBOARD + "/CompanyWeekEnds/" + companyid).pipe(map(res => res.json()));
    }
    //added by senthilg
    getProjects(CompanyId: number) {debugger;
        return this.http.get(API.PROJECT + "/GetProjects/" + CompanyId).pipe(map(resp => resp.json()));
    }
    //added by senthil g for share tech
    getVendorList(CompanyId: number, LoginId: number, MaxRoleGroup: number, ProjectId: string, VendorId?: number): Observable<VendorList[]> {debugger;
        return this.http.get(API.DISPATCHBOARD + "/GetProjectBasedVendors/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + '/' + ProjectId + '/' + VendorId).pipe(map(res => res.json()));
    }
    //Get Config master dropdown list - Veeramani
    getConfigMasterDrpdwnList(companyId: number, configId: number): Observable<Config[]> {
        return this.http.get(API.CONFIGMASTER + "/GetAll/" + companyId + "/" + configId).pipe(map(res => res.json()));
    }
    //Get system settigs by id - Veeramani
    getSystemSettings(companyId: number, settingId: number): Observable<SystemSetting[]> {
        return this.http.get(API.SYSTEMSETTING + "/GetSystemSettingByIds/" + companyId + "/" + settingId).pipe(map(res => res.json()));

    }

    getJobSLADetails(jobId: number, companyId: number): Observable<JobSlaDetails[]> {
        return this.http.get(API.DISPATCHBOARD + "/GetJobSLADetails/" + jobId + '/' + companyId).pipe(map(res => res.json()));
    }
    getSmsLog(companyId: number, jobId: number): Observable<Smslog[]> {
        return this.http.get(API.DISPATCHBOARD + "/GetSmslog/" + companyId + '/' + jobId).pipe(map(res => res.json()));
    }


    getTechnicianPopupDetails(param: techaddressparam): Observable<TechnicianPopupDetails> {
        return this.http.post(API.DISPATCHBOARD + "/getTechnicianPopupDetails", param).pipe(map(res => res.json()));
    }

    GetTechnicianPhoto(CompanyId: number, FileName: string) {
        return this.http.get(API.USER + "/GetUserTheme/?CompanyId=" + CompanyId + "&FileName=" + FileName).pipe(map(res => res.json()));
    }

    getCustomerVendorList(CompanyId: number, LoginId: number, MaxRoleGroup: number, ProjectId: number,CustomerId: number, VendorId?: number): Observable<VendorList[]> {
        return this.http.get(API.USER + "/GetCustomerVendorList/" + CompanyId + "/" + LoginId + "/" + MaxRoleGroup + "/"+ CustomerId + "/?ProjectId=" + ProjectId + '&VendorId=' + VendorId).pipe(map(res => res.json()));
    }

}